


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import Icons from '@/shared/icons/icons.json';
import AuthorityStore from '@/domain/security/authority.store';
import Authority from '@/domain/security/authority.entity';
import ProjectPersist from '../../domain/project/project-persist.entity';

@Component
export default class ProjectCardComponent extends Vue {
  @Prop({
    required: true,
    default: new ProjectPersist(),
  })
  private project!: ProjectPersist;

  private icons: any[] = Icons;

  private authorities: Authority = new Authority([]);

  created() {
    this.checkAutorities();
  }

  private clickIcon(icon: any): void {
    if (icon.path) this.$router.push(`/${this.$route.params.projectName}/${icon.path}`);
    if (icon.title === 'editProject') this.openEditProjectModal();
  }

  private openEditProjectModal(): void {
    this.$emit('editProject');
  }

  private checkAutorities() {
    AuthorityStore.fetchedAuthority()
      .then((resp: Authority) => this.authorities = resp);
  }

  get getFilteredIcons(): string[] {
    return this.icons!!.filter((el: any) => {
      if (el.authorities.length > 0) {
        return this.authorities.hasAuthorities(el.authorities);
      }
      return true;
    });
  }
}
